import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs/Subscription";

@Component({
  selector: 'app-current-batch-transaction-detail',
  templateUrl: './current-batch-transaction-detail.component.html',
  styleUrls: ['./current-batch-transaction-detail.component.css'],
  providers: [DiamondPayDataService]
})
export class CurrentBatchTransactionDetailComponent implements OnInit {
  private routeSubscription: Subscription;
  private transaction: any;

  constructor(private dataService:  DiamondPayDataService,
              private route:        ActivatedRoute,
              private router:       Router) { }

  ngOnInit() {
      this.routeSubscription = this.route.params.subscribe(params => {
        this.dataService
            .RetrieveDiamondPayTransaction(params['id'])
            .subscribe((response:any) => this.transaction = response, error => console.log(error));
      });

  }

  removeFromCurrentBatch(transaction) {
      this.dataService.removeFromCurrentBatch(transaction)
          .subscribe((result) => this.router.navigateByUrl('/app/diamond-pay/queued-transactions'));
  }

}



// WEBPACK FOOTER //
// ./src/app/current-batch-transaction-detail/current-batch-transaction-detail.component.ts